import {Routes} from '@angular/router';

import {PHONE_ROUTES} from './phone/phone.routes';
import { CLIENT_ROUTES} from './client/client.routes';
import {DashboardComponent} from './core/components/dashboard/dashboard.component';
import { ActionHistoryComponent} from './shared/components/action-history/action-history.component';
import {ROBINSON_ROUTES} from './robinson/robinson.routes';
import {ListServicesComponent} from './core/components/services/list-services/list-services.component';
import {EditServiceComponent} from './core/components/services/edit-service/edit-service.component';

export const APP_ROUTES: Routes = PHONE_ROUTES.concat(
    PHONE_ROUTES,
    CLIENT_ROUTES,
    ROBINSON_ROUTES,
    [
        { path: 'dashboard', component: DashboardComponent },
        { path: 'services', component: ListServicesComponent},
        { path: 'service/edit/:pk', component: EditServiceComponent},
        { path: 'service/create', component: EditServiceComponent},
        { path: 'action', component: ActionHistoryComponent },
    ]
);



// WEBPACK FOOTER //
// /var/www/backend/src/app/app.routes.ts